import React from "react";
import { useSessionNotifications } from "../../../hooks/useSessionNotifications";

/**
 * Component that handles session notifications globally
 * This component should be placed at the root level to listen for all session notifications
 */
const SessionNotificationHandler: React.FC = () => {
  useSessionNotifications();

  // This component doesn't render anything, it just handles notifications
  return null;
};

export default SessionNotificationHandler;
